<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    badge: {
      type: String,
      default: ""
    }
  },
  render(h, context) {
    const {icon, title, badge} = context.props
    const vnodes = []

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon}/>)
    }

    if (title) {
      var titleHtml = <span slot='title'>{(title)}</span>
      if (title == '费用管理' || title == '缴费管理' || title == '功能开通申请') {
        if(badge!=0){
          titleHtml = <span slot='title'>{(title)}<span class="custom-badge">{(badge)}</span></span>
        }else {
          titleHtml = <span slot='title'>{(title)}</span>
        }
      }
      vnodes.push(titleHtml)
    }
    return vnodes
  }
}
</script>
